module.exports = __webpack_public_path__ + "static/img/func-bg.e03bfc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/func-bg.png
// module id = 2ON0
// module chunks = 0